export class Model {
  constructor(partial?: Partial<any>) {
    if (partial) {
      return this.load(partial);
    }
  }

  load(partial: Partial<any>) {
    return Object.assign(this, partial);
  }
}
